import { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    TableHead, TableRow, TableCell, TableBody, Tooltip, IconButton, Table
} from '@mui/material';
import Moment from 'react-moment';
import axios from 'axios';
import { CircleLoader } from 'components';
import { MdHistory, MdFileDownload } from 'react-icons/md';

interface IProps {
    documentId: string
}

interface IDocRevisions {
    fileId: string
    title: string
    createdBy: string
    createdOn: moment.Moment
    revisionNr: number
}

let DocumentRevisions = ({ documentId }: IProps) => {
    let [isLoading, setLoading] = useState(true);
    let [isOpen, setOpen] = useState(false);
    let [docRevisions, setDocRevisions] = useState<IDocRevisions[]>([]);



    let open = async () => {
        try {
            setLoading(true);
            setOpen(true);

            let res = await axios.get('/api/Ticket/GetDocumentRevisions', { params: { documentId } });
            setDocRevisions(res.data.items);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    let downloadDocument = async (documentId: string, revisionNr: number) => {
        try {
            let res = await axios.get('/api/Ticket/DownloadDocument', { params: { documentId, revisionNr } })
            window.location.href = res.data;
        } catch (err) { }
    }


    return <>
        <Tooltip title="Mostra revisioni precedenti">
            <IconButton size="small" onClick={async () => await open()}>
                <MdHistory />
            </IconButton>
        </Tooltip>
        <Dialog open={isOpen} fullWidth maxWidth="md">
            <DialogTitle>Revisioni documento</DialogTitle>
            <DialogContent>
                {isLoading && <CircleLoader />}
                {isLoading === false &&
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Nome file</TableCell>
                                <TableCell align="center">Revisione</TableCell>
                                <TableCell>Caricato</TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {docRevisions.map((rev, index) =>
                                <TableRow key={index}>
                                    <TableCell>{rev.title}</TableCell>
                                    <TableCell align="center" >{rev.revisionNr}</TableCell>
                                    <TableCell>
                                        {rev.createdBy}&nbsp;<Moment date={rev.createdOn} format="LL" />
                                    </TableCell>
                                    <TableCell>
                                        <Tooltip title="download">
                                            <IconButton onClick={() => downloadDocument(rev.fileId, rev.revisionNr)} size="large">
                                                <MdFileDownload />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)} color="secondary">Chiudi</Button>
            </DialogActions>
        </Dialog>
    </>;
}

export default DocumentRevisions;